export default "__VITE_ASSET__Do1_BZ2A__"